/**
 * Helper function that returns true if the given two arrays have the same
 * elements, false otherwise.
 *
 * @param {Array} a
 * @param {Array} b
 */
export const arraysEqual = (a, b) =>
	a.length === b.length && a.every(elem => b.indexOf(elem) !== -1);

/**
 * Helper function that returns true if the given two arrays have the same
 * elements and are sorted the same, false otherwise.
 *
 * @param {Array} a
 * @param {Array} b
 */
export const arraysSame = (a, b, deep = false) =>
	a.length === b.length &&
	a.every((elem, index) => {
		const other = b[index];
		if (deep && Array.isArray(elem) && Array.isArray(other)) {
			return arraysSame(elem, other);
		} else {
			return other === elem;
		}
	});

/**
 *
 * @param {Array} array
 * @returns {Integer}
 */
export const sum = array => array.reduce((acc, curr) => acc + curr, 0);

export const chunk = (chunkSizes, array) => {
	let index = 0;
	let chunkIndex = 0;
	const chunks = [];
	while (index < array.length) {
		const chunkSize = chunkSizes[Math.min(chunkIndex, chunkSizes.length - 1)];
		chunks.push(array.slice(index, index + chunkSize));
		index += chunkSize;
		chunkIndex++;
	}
	return chunks;
};

/**
 * @param {Array} list
 * @param {Integer} sourceIndex
 * @param {Integer} targetIndex
 * @return {Array}
 */
export function moveElem(list, sourceIndex, targetIndex) {
	if (!list.length) {
		return list;
	}
	const copy = pad([...list], targetIndex);
	const item = copy[sourceIndex];
	copy.splice(sourceIndex, 1);
	copy.splice(
		sourceIndex < targetIndex ? targetIndex - 1 : targetIndex,
		0,
		item,
	);
	return copy;
}

export function* interweave(...arrays) {
	for (let i = 0; i < Math.max(0, ...arrays.map(a => a.length)); i++) {
		for (let array of arrays) {
			if (array.length > i) {
				yield array[i];
			}
		}
	}
}

/**
 * @param {array} a
 * @param {array} b
 * @return {array} elements of a not included in b, and elements of b not included in a
 */
export function diff(a, b) {
	return a.filter(x => !b.includes(x)).concat(b.filter(x => !a.includes(x)));
}

export function pad(array, num, item = undefined) {
	if (num <= array.length) {
		return array;
	}

	return array.concat(new Array(num - array.length).fill(item));
}
